import { render } from "./AdminOrderItemCreate.vue?vue&type=template&id=51e01cef&scoped=true&ts=true&lang=true"
import script from "./AdminOrderItemCreate.vue?vue&type=script&lang=ts"
export * from "./AdminOrderItemCreate.vue?vue&type=script&lang=ts"

import "./AdminOrderItemCreate.vue?vue&type=style&index=0&id=51e01cef&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e01cef"]])

export default __exports__